import FeatureCards from "@/components/design/FeatureCards";
import Reveal from "@/components/Motion/Reveal";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Vorteile() {

    const navigate = useNavigate()
  const featureContent = [
    {
      title: "Bewerten",
      description: "Erfahren Sie kostenlos und unverbindlich was Ihre Immobilie wert ist.",
      icon: "/Icons/landingpage-leistungen-bewerten.svg",
      url: "/bewerten",
      buttonText: "Marktwert erfahren",
      alt: "Kostenlose Immobilienbewertung online",
    },
    {
      title: "Verkaufen",
      description: "Mit Erfahrung und Marktkenntnis zum besten Verkaufsergebnis.",
      icon: "/Icons/landingpage-leistungen-verkaufen.svg",
      url: "/verkaufen",
      buttonText: "Immobilie verkaufen",
      alt: "Immobilie verkaufen",


    },
    {
      title: "Kaufen",
      description: "Finden Sie Ihr neues Zuhause – mit Beratung, die zu Ihnen passt.",
      icon: "/Icons/landingpage-leistungen-kaufen.svg",
      url: "/immobilien",
      buttonText: "Immobilien entdecken",
      alt: "Immobilie kaufen",


    },

    {
      title: "Vermieten",
      description: "Sichere Vermietung, die Ihnen wertvolle Zeit und Nerven spart. ",
      icon: "/Icons/landingpage-leistungen-vermieten.svg",
      url: "/vermieten",
      buttonText: "Mieter finden",
      alt: "Immobilie vermieten",


    },
  ];
  return (
    <div className="max-w-7xl pb-10 mx-auto">
      <div>
        <h2 className="relative md:text-3xl text-2xl xl:text-4xl  w-fit mx-auto text-center font-medium py-10 pb-16 pt-20 md:pt-0 text-white">
          Unsere Leistungen für Sie
        </h2>
      </div>
      <div className="md:flex-row  md:flex flex-col justify-evenly items-center px-1 py-5 md:py-10 ">
        {featureContent.map((feature, index) => (
          <Reveal 
            key={index}
            delay={0.1 + index * 0.1}
          >
          <FeatureCards
            url={feature.url}
            buttonText={feature.buttonText}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
            className=" min-h-[21rem] md:w-full border-none hover:scale-105 mt-5 mx-5 md:mx-0 transition-all duration-300"
            alt={feature.alt}
          />
          </Reveal>
        ))}
      </div>
    </div>
  );
}
